<template>
  <table class="v-datatable v-table">
    <thead>
        <tr>
            <th class="column text-xs-left">GUESTS</th>
            <th class="column text-xs-left">TOTAL ARRANGEMENT FEE</th>
            <th class="column text-xs-left">AGENCY PASSTHROUGH</th>
            <th class="column text-xs-left">TOTAL COST</th>
            <th class="column text-xs-left">TOTAL SALES</th>
            <th class="column text-xs-left">COMMISSION</th>
            <th class="column text-xs-left">CONTRACTUAL</th>

        </tr>
    </thead>
    <tbody>
        <tr>
            <td>{{guests}}</td>
            <td>{{arrangementFee | currency}}</td>
            <td>{{agencyPassthrough | currency}}</td>
            <td>{{costs | currency}}</td>
            <td>{{sales | currency}}</td>
            <td>{{commission | currency}}</td>
            <td>{{contractualCommission | currency}}</td>
        </tr>
    </tbody>
  </table>

</template>
<script>
import Enumerable from 'linq'
import { mapGetters } from 'vuex'

export default {
  props: {
    eventGroupId: {
      type: Number
    }
  },
  components: {

  },
  data() {
    return {
    
    }
  },
  computed: {
    ...mapGetters([
      'reportingData'
    ]),
    season: {
			get () {
				return this.$store.state.settings.season	
			},
			set (id) {
				this.$store.dispatch('setSeason', id)
					.then(() => this.$store.dispatch('setUserSeason', id))
			}
    },
    guests: function () {
				if (this.reportingData.length > 0 && this.season) {
					let enumerable = Enumerable
						.from(this.reportingData)
            .where(item => item['wo_status'] === 2 && (item['FK_ArticleType'] === 10 || item['FK_ArticleType'] === 1 || item['FK_ArticleType'] === 2))
            .where(item => item['event_group_id'] === this.eventGroupId)

					return enumerable
						.select(item => item['Menge'])
						.sum()
				} else {
					return 0
				}
			},
     sales: function () {
      if (this.reportingData.length > 0 && this.season) {
        let enumerable = Enumerable
          .from(this.reportingData)
          .where(item => item['wo_status'] === 2)
          .where(item => item['event_group_id'] === this.eventGroupId)

        return enumerable
          .select(item => item['sales_total'])
          .sum()
      } else {
        return 0
      }
    },
    costs: function () {
    	if (this.reportingData.length > 0 && this.season) {
    		let enumerable = Enumerable
    			.from(this.reportingData)
          .where(item => item['wo_status'] === 2)
          .where(item => item['event_group_id'] === this.eventGroupId)

  
    		return enumerable
    			.select(item => item['costs_total'])
    			.sum()
    	} else {
    		return 0
    	}
    },
    arrangementFee: function () {
      if (this.reportingData.length > 0 && this.season) {
        let enumerable = Enumerable
          .from(this.reportingData)
          .where(item => item['wo_status'] === 2)
          .where(item => item['event_group_id'] === this.eventGroupId)

  
        return enumerable
          .select(item => item['arrangement_fee'])
          .sum()
      } else {
        return 0
      }
    },
    agencyPassthrough: function () {
      if (this.reportingData.length > 0 && this.season) {
        let enumerable = Enumerable
          .from(this.reportingData)
          .where(item => item['wo_status'] === 2)
          .where(item => item['event_group_id'] === this.eventGroupId)


        return enumerable
          .select(item => Number(item['agency_value'] || 0))
          .sum()
      } else {
        return 0
      }
    },
    commission: function () {
      if (this.reportingData.length > 0 && this.season) {
        let enumerable = Enumerable
          .from(this.reportingData)
          .where(item => item['wo_status'] === 2)
          .where(item => item['event_group_id'] === this.eventGroupId)

  
        return enumerable
          .select(item => item['commission'])
          .sum()
      } else {
        return 0
      }
    },
    contractualCommission: function () {
      if (this.reportingData.length > 0 && this.season) {
        let enumerable = Enumerable
          .from(this.reportingData)
          .where(item => item['wo_status'] === 2)
          .where(item => item['event_group_id'] === this.eventGroupId)

  
        return enumerable
          .select(item => item['contractualCommission'])
          .sum()
      } else {
        return 0
      }
    },
    soldTickets: function () {
      if (this.reportingData.length > 0 && this.season) {
        let enumerable = Enumerable
          .from(this.reportingData)
          .where(item => item['wo_status'] === 2)
          .where(item => item['FK_ArticleType'] === 10 || item['FK_ArticleType'] === 1 || item['FK_ArticleType'] === 2)
          .where(item => item['event_group_id'] === this.eventGroupId)

        return enumerable
          .select(item => item['Menge'])
          .sum()
      } else {
        return 0
      }
    }
  },
  methods: {
	 
  },
  created() {

  }
}
</script>
<style>
    .button-row {
        padding-top: 15px !important;
    }
</style>